import $apiPrivate from '@/api/apiPrivate';

const getUser = async () => {
  const response = await $apiPrivate.get('clients/me');
  return response;
};

export default {
  getUser,
};
